(() => {
  if (window.liberoThemeController) {
    window.liberoThemeController.refresh();
    return;
  }
  const root = document.documentElement;
  const earlyProductMode = root.dataset.liberoProductBoot === 'true';
  let stored;
  if (earlyProductMode) stored = root.dataset.liberoTheme;
  else { try { stored = localStorage.getItem('libero-theme'); } catch {} }
  const preferred = window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'night' : 'day';
  const apply = (mode) => {
    if (!earlyProductMode || root.dataset.liberoTheme !== mode) root.dataset.liberoTheme = mode;
    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
      const label = button.querySelector('[data-theme-label]');
      const text = mode === 'night' ? button.dataset.dayLabel : button.dataset.nightLabel;
      const pressed = mode === 'night' ? 'true' : 'false';
      const action = mode === 'night' ? button.dataset.dayAction : button.dataset.nightAction;
      if (label && (!earlyProductMode || label.textContent !== text)) label.textContent = text;
      if (!earlyProductMode || button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      if (!earlyProductMode || button.getAttribute('aria-label') !== action) button.setAttribute('aria-label', action);
    });
  };
  const refresh = () => apply(root.dataset.liberoTheme === 'night' ? 'night' : 'day');
  window.liberoThemeController = { refresh };
  apply(stored === 'night' || stored === 'day' ? stored : preferred);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-theme-toggle]') : null;
    if (!button) return;
    const next = root.dataset.liberoTheme === 'night' ? 'day' : 'night';
    try { localStorage.setItem('libero-theme', next); } catch {}
    apply(next);
  });
})();

(() => {
  if (window.liberoNavigationInitialized) return;
  window.liberoNavigationInitialized = true;
  const getHeader = () => document.querySelector('.libero-header');
  let menusOpen = false;
  let scrollFrame = null;
  const closeMenus = () => {
    menusOpen = false;
    const header = getHeader();
    if (!header) return;
    header.querySelectorAll('.libero-nav > details[open], .libero-mobile[open]').forEach((menu) => {
      menu.open = false;
    });
  };
  const syncMobileLabel = (menu) => {
    const trigger = menu.querySelector(':scope > summary');
    if (!trigger) return;
    trigger.setAttribute('aria-label', menu.open ? trigger.dataset.closeLabel : trigger.dataset.openLabel);
    const label = trigger.querySelector('[data-libero-mobile-label]');
    if (label) label.textContent = menu.open ? trigger.dataset.closeText : trigger.dataset.openText;
  };

  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement) || !menu.closest('.libero-header')) return;
    if (menu.matches('.libero-nav > details') && menu.open) {
      menu.parentElement.querySelectorAll(':scope > details[open]').forEach((other) => {
        if (other !== menu) other.open = false;
      });
    }
    if (menu.matches('.libero-mobile__drawer > details') && menu.open) {
      menu.parentElement.querySelectorAll(':scope > details[open]').forEach((other) => {
        if (other !== menu) other.open = false;
      });
    }
    menusOpen = Boolean(getHeader()?.querySelector('.libero-nav > details[open], .libero-mobile[open]'));
    previousScrollY = window.scrollY;
    if (menu.matches('.libero-mobile')) {
      if (!menu.open) menu.querySelectorAll('details[open]').forEach((nested) => { nested.open = false; });
      syncMobileLabel(menu);
    }
  }, true);

  const closeOnOutside = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.libero-nav > details, .libero-mobile')) closeMenus();
  };
  document.addEventListener('click', closeOnOutside);
  const refreshMobileLabels = () => getHeader()?.querySelectorAll('.libero-mobile').forEach(syncMobileLabel);
  refreshMobileLabels();
  document.addEventListener('shopify:section:load', refreshMobileLabels);
  document.addEventListener('focusin', (event) => {
    const header = getHeader();
    if (!header || !header.querySelector('.libero-nav > details[open], .libero-mobile[open]')) return;
    if (!(event.target instanceof Element) || !event.target.closest('.libero-nav > details[open], .libero-mobile[open]')) closeMenus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const header = getHeader();
    if (!header) return;
    const openMenus = header.querySelectorAll('.libero-mobile__drawer > details[open], .libero-mobile[open], .libero-nav > details[open]');
    const menu = openMenus[openMenus.length - 1];
    if (!menu) return;
    event.preventDefault();
    menu.open = false;
    menu.querySelector(':scope > summary')?.focus();
  });

  let previousScrollY = window.scrollY;
  window.addEventListener('scroll', () => {
    if (!menusOpen || scrollFrame !== null) return;
    scrollFrame = requestAnimationFrame(() => {
      scrollFrame = null;
      if (Math.abs(window.scrollY - previousScrollY) > 8) closeMenus();
      previousScrollY = window.scrollY;
    });
  }, { passive: true });
})();

